import React from "react";

import { Trans } from "react-i18next";
import { Link } from "react-router-dom";

import { longDate } from "../../utils/DateHelper";
import { getEncodedValue } from "../../utils/Helpers";
import ProductTags from "../Tags/ProductTags";

const ProductBriefCard = ({ product }) => {
    const getProductName = () => {
        return getEncodedValue(product?.id || product?.value);
    };

    return (
        <>
            <div className="flex flex-col p-3 product-brief-card">
                <div className="rate-items flex items-center justify-between flex-wrap mb-6">
                    <div className="text-primary-orange">
                        <span className="uppercase text-xxs text-secondary-color-lighter-blue mr-1">
                            version
                        </span>
                        {product?.version}
                    </div>
                    <div className="market-downloaded-number">
                        {longDate(product?.publishedAt)}
                    </div>
                </div>
                <div className="market-header mb-1">
                    <h3 className="medium-title-bold break-words">
                        {product?.productName || product?.label}
                    </h3>
                    <div className="text-xs success">
                        {product?.materialName || ""}
                        {product?.materialNames
                            ? [...new Set(product?.materialNames)].join(", ")
                            : ""}
                    </div>
                </div>
                <div className="model-description-wrapper">
                    <p className="model-description">{product?.description}</p>
                </div>
                <div className="mb-2">
                    <ProductTags tags={product?.parameters} />
                </div>
                <button className="default-orange-outline-btn self-end text-xs">
                    <Link
                        to={{
                            pathname: `/store/product/${getProductName()}`,
                            state: { from: location.pathname },
                        }}
                        className="w-full h-full"
                    >
                        <Trans i18nKey="seeMore">see more</Trans>
                    </Link>
                </button>
            </div>
        </>
    );
};

export default ProductBriefCard;
